import { createStyles } from 'antd-style';

import { ThemeColors, ThemeSpaces, hexToRgbaWithAlpha } from '../../theme';

export const useNewShipmentDialogsStyles = createStyles(({ token }) => ({
  newShipmentSelectAccountDialog: {
    '&&': {
      '.SimpleDialog-Icon': {
        '> img': {
          width: 54,
          height: 57,
        },
        '&::before': {
          top: 4,
          left: 11,
          right: 1,
          bottom: 14,
        },
      },

      '.ant-modal-body': {
        padding: `${ThemeSpaces.SPACE_XL}px ${ThemeSpaces.SPACE_NORM_25}px ${ThemeSpaces.SPACE_NORM_15}px ${ThemeSpaces.SPACE_NORM_25}px`,
      },

      'h1.ant-typography': {
        [`@media (max-width: ${token.screenSMMax}px)`]: {
          fontSize: token.fontSizeHeading2,
        },
      },
    },
  },
  orderSuccessDialog: {
    '&&': {
      '.ant-btn': {
        width: '100%',
        border: `1px solid ${token.colorWhite}`,
        boxShadow: `0 4px 20px ${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY_BLUISH, 0.85)}`,

        '&.ant-btn-lg': {
          fontSize: token.fontSizeHeading4,
          fontWeight: 500,
        },
      },
    },
  },
}));
